import React from 'react';
import { MessageGroup } from '../../../types/chat';
import MessageBox from './MessageBox';
import { Divider } from 'antd';
import { formatDate } from '../../../_utils/date';

import { useEffect, useRef } from 'react';
import { useChat } from '../../../store/slices/chat';
import { DocumentText } from 'iconsax-react';
import InfoText from '../../../components/atoms/InfoText';
import LoaderSpin from '../../../components/atoms/LoaderSpin';
import { useTranslation } from 'react-i18next';

type Props = { messages?: MessageGroup[]; chatLoading: boolean };

const ChatContent = ({ messages, chatLoading }: Props) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const { selectedRoomId } = useChat();

  const { t, i18n } = useTranslation();

  //todo: not working !!!
  useEffect(() => {
    if (!!messages) {
      if (contentRef.current) {
        contentRef.current.scrollTo({
          top: contentRef.current.scrollHeight,
          behavior: 'smooth',
        });
      }
    }
  }, [messages]);

  return (
    <div ref={contentRef}>
      {/* {false && (
        <div className="flex flex-col items-center justify-center h-full w-full">
          <DocumentText size={200} variant="Bulk" className="text-pink-400" />
          <InfoText text="Choose proposal to chat about, From proposals button" />
        </div>
      )} */}
      {chatLoading && selectedRoomId ? (
        <LoaderSpin />
      ) : (
        <>
          {messages?.map((msgGroup) => {
            return (
              <div key={msgGroup?.date}>
                {!!msgGroup?.date && (
                  <Divider className="border-light-input-border dark:border-dark-input-border">
                    <span className="text-light-text-primary dark:text-dark-text-primary">
                      {formatDate(msgGroup?.date, i18n?.language, t)}
                    </span>
                  </Divider>
                )}
                {msgGroup?.messages?.map((msg) => (
                  <MessageBox key={msg.id} {...msg} />
                ))}
              </div>
            );
          })}
        </>
      )}
    </div>
  );
};

export default ChatContent;
